import React from 'react';

const MobileDeviceIconBlack = () => {
  return (
    <svg width="36" height="60" viewBox="0 0 36 60" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M29.8419 0.891602H6.15859C3.0658 0.891602 0.558594 3.39881 0.558594 6.4916V53.5083C0.558594 56.6011 3.0658 59.1083 6.15859 59.1083H29.8419C32.9347 59.1083 35.4419 56.6011 35.4419 53.5083V6.4916C35.4419 3.39881 32.9347 0.891602 29.8419 0.891602ZM22.3752 53.2749H13.6252C12.852 53.2749 12.2252 52.6481 12.2252 51.8749C12.2252 51.1017 12.852 50.4749 13.6252 50.4749H22.3752C23.1484 50.4749 23.7752 51.1017 23.7752 51.8749C23.7752 52.6481 23.1484 53.2749 22.3752 53.2749Z" fill="#333333" />
    </svg>
  );
}

export default MobileDeviceIconBlack;